export enum ContextTypes {
  YEAR = 1,
  MONTH = 2,
  QUARTER = 3,
  WEEK = 4,
}

export type TBaseViewsCountTableItem = {
  name: string;
  viewsCount: number;
  path: string;
};

export type TTreeViewsCountTableItem = TBaseViewsCountTableItem & {
  children: TTreeViewsCountTableItem[];
};

export type TPagesTableItem = TBaseViewsCountTableItem;

export type TSectionsTableItem = TTreeViewsCountTableItem;

export type TViewsCountByTimeTableItem = {
  period: string;
  viewsCount: number;
};

export type TStatisticsChartItem = {
  value: number;
  label: string;
  text: string;
};

export type TVisitsCountTreeTableItem = {
  name: string;
  visitsCount: number;
  children: TVisitsCountTreeTableItem[];
};

export type TStatisticsChartLegends = {
  column: string;
  firstLine?: string;
  secondLine?: string;
  thirdLine?: string;
  fourthLine?: string;
};

export type TStatisticsChartWithLegendsItem = Pick<TStatisticsChartItem, 'label' | 'text'> & {
  column: number;
  firstLine?: number;
  secondLine?: number;
  thirdLine?: number;
  fourthLine?: number;
};

export type TStatisticsChartWithLegends = {
  legends: TStatisticsChartLegends;
  items: TStatisticsChartWithLegendsItem[];
};
